import { delete_cookie } from "../cookies";

declare const window: any;

export const shouldComponentRender = (prevProps, nextProps) => {
    
    if(prevProps.lineItemId && nextProps.lineItemId){
        const {cart: prevCart = {}, lineItemId: prevLineItemId, error : prevError = {}} = prevProps;
        const {cart: nextCart = {}, lineItemId: nextLineItemId, error : nextError = {}} = nextProps;
        
        const prevProduct = prevCart?.lineItems[prevLineItemId] ?? [];
        const nextProduct = nextCart?.lineItems[nextLineItemId] ?? [];

        return JSON.stringify(prevProduct) === JSON.stringify(nextProduct) && JSON.stringify(prevError) === JSON.stringify(nextError) && (prevCart?.validDiscountCode === nextCart?.validDiscountCode);
    }
    
    const {cart: prevCart = {}, error : prevError = {}} = prevProps;
    const {cart: nextCart = {}, error : nextError = {}} = nextProps;
        
    return JSON.stringify(prevCart) === JSON.stringify(nextCart) && JSON.stringify(prevError) === JSON.stringify(nextError) && (prevCart?.validDiscountCode === nextCart?.validDiscountCode);
};

export const setAuthorizationHeader = (headers) => {
    const newHeaders = window.np.getMcpAuthHeader()||{};
    Object.entries(newHeaders).forEach(([key, value]) => {
        if(typeof(value)==='string'){
            headers.set(key, value);
        }
    });
}
export const deleteAuthfrontCookiesAndRedirectToHome = () => {
    try {
        const redirectTo = window.locale_details.site_baseurl + '?d=' +  new Date().getTime();
        // Delete all auth and session-related cookies
        delete_cookie('authfront_refresh_token');
        delete_cookie('authfront_access_token');
        delete_cookie('authfront_access_token_type');
        localStorage.removeItem('authfront_token_details');
        // Redirect to home
        window.location.replace(redirectTo);
    } catch (error) {
        console.error('Error during redirect:', error);
    }
}   